<template>
  <div>
    <div class="vform-hint mb-3">{{ $t('vform.partInfoHint') }}</div>
    <div class="mb-3">
      <label class="vform-editor-label section">{{ $t('Choose display information') }}</label>
      <select v-model="element.partInfo" class="custom-select form-text-dark">
        <option v-for="view in infoTypesDataSource" :key="view" :value="view">
          {{ $t(`vform.${view}`) }}
        </option>
      </select>
    </div>
    <label class="vform-editor-label section">Border Color</label>
    <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)"/>
    <color-picker-and-field
        v-else
        :field-background-color="element.borderColor"
        @saveColor="(color) => {setItemColor('borderColor', color)}"
        @unsetColor="setItemColor('borderColor', null)"
    />

    <label class="vform-editor-label section">Font Color</label>
    <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)"/>
    <color-picker-and-field
        v-else
        :field-background-color="element.fontColor"
        @saveColor="(color) => {setItemColor('fontColor', color)}"
        @unsetColor="setItemColor('fontColor', null)"
    />

    <label class="vform-editor-label section">Background Color</label>
    <set-by-template v-if="!templateEditing && !isObjectEmpty(selectedTemplate)"/>
    <color-picker-and-field
        v-else
        :field-background-color="element.backgroundColor"
        @saveColor="(color) => {setItemColor('backgroundColor', color)}"
        @unsetColor="setItemColor('backgroundColor', null)"
    />
    <meta-fields-selection
        :organization-id="organizationId"
        :selected-meta-fields="element.metaFields ? element.metaFields : []"
        :include-super-org-metasets="superOrgMetasets"
        @updateMetaFieldSelection="updateMetaFieldSelection"
    />
  </div>
</template>

<script>
import vFormElementMixin from "@/components/vForm/vFormElementMixin.js";
import {vFormControls, placeholders} from "@/enum";
import MetaFieldsSelection from "@/components/vForm/MetaFieldsSelection.vue";
import ColorPickerAndField from "@/components/widgets/editors/ColorPickerAndField.vue";

export default {
  name: "vFormPART_INFO",
  components: {
    ColorPickerAndField,
    MetaFieldsSelection,
  },
  mixins: [vFormElementMixin],
  props: {
    element: {type: Object, required: true},
    organizationId: {type: String, default: ""},
  },
  data() {
    return {
      forceReRenderKey: 0,
      vFormControls: vFormControls,
      placeholders: placeholders,
      infoTypesDataSource: ['metaInfo'],
      metaSets: null,
      superOrgMetasets: ["sfx.asset.model", "sfx.asset.transform", "sfx.asset.assembly"]
    };
  },
  beforeMount() {
    this.element.formElementType = vFormControls["PART_INFO"];
    if (!this.element.partInfo) {
      this.element.partInfo = "metaInfo";
    }
  },
  methods: {
    updateMetaFieldSelection(selectedMetaFields) {
      console.log('selectedMetaFields', selectedMetaFields);
      this.$set(this.element, "metaFields", selectedMetaFields);
    },
  }
};
</script>
<style lang="scss" scoped>
.tree-collapse {
  position: absolute;
  top: -2px;
}
</style>